import { render, staticRenderFns } from "./addLanuch.vue?vue&type=template&id=5132dd9c&scoped=true&"
import script from "./addLanuch.vue?vue&type=script&lang=js&"
export * from "./addLanuch.vue?vue&type=script&lang=js&"
import style0 from "./addLanuch.vue?vue&type=style&index=0&id=5132dd9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132dd9c",
  null
  
)

export default component.exports